import { constants } from '@/config';

const App = () => import('@/app/linkedin/App.vue');
const Overview = () => import('@/app/analytics/pages/ChannelOverviewPage.vue');
const AnalyticsYourPostsPage = () => import('@/app/analytics/pages/AnalyticsYourPostsPage.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');

const PAGE_LEVEL_TOP = 'LinkedIn';
const PAGE_LEVEL_BOARDS = 'Boards';

export default {
  path: 'linkedin',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'linkedin',
      path: '',
      redirect: { name: 'linkedin.overview' },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'linkedin.overview',
      path: 'overview',
      component: Overview,
      props: { channel: constants.LINKEDIN, key: constants.LINKEDIN },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'linkedin.overview.report',
      path: 'overview/report',
      component: Overview,
      props: { channel: constants.LINKEDIN, key: constants.LINKEDIN },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview Report`,
        report: true,
      },
    },
    {
      name: 'linkedin.yourPosts',
      path: 'your-posts',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.LINKEDIN,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts`,
      },
    },
    {
      name: 'linkedin.yourPosts.report',
      path: 'your-posts/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.LINKEDIN,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts Report`,
        report: true,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'linkedin.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.LINKEDIN,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_BOARDS}`,
          },
        },
      ],
    },
  ],
};
